<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import '@/assets/styles/global.css'

export default {
  name: 'App'
}
</script>


// WEBPACK FOOTER //
// src/App.vue